/**
 * This component will work for sorting the filter
 *
 * @module views/components/FilterResultsAction
 * @memberof -Common
 */
import './FilterResultsAction.scss';

import React from 'react';

import PropTypes from 'prop-types';

import DropDown from '@ulta/core/components/DropDown/DropDown';
import Text from '@ulta/core/components/Text/Text';

/**
 * Represents a FilterResultsAction component
 *
 * @method
 * @param {FilterResultsActionProps} props - React properties passed from composition
 * @returns FilterResultsAction
 */
export const FilterResultsAction = function( props ){
  const {
    sortLabel,
    sortItems,
    onChange
  } = props;

  if( !Array.isArray( sortItems ) || sortItems.length === 0 ){
    return null;
  }

  return (
    <div className='FilterResultsAction__container'>
      <div className='FilterResultsAction__label'>
        <Text htmlTag='span'
          textStyle='body-2'
          color='neutral-600'
        >
          { sortLabel }
        </Text>
      </div>
      <div className='FilterResultsAction__dropdown'>
        <DropDown
          options={ sortItems }
          selectAction={ onChange }
          ariaLabel={ props.sortLabel }
        />
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef FilterResultsActionProps
 * @type {object}
 * @property { string } sortLabel - label for the Dropdown
 * @property { func } onChange - onChange Event on Dropdown
 * @property { object.<{label: string, url: string, graphql: string }> } sortAction - Provides the label, url & graphql query
 * @property { object.<{id: string, action: object, selected: boolean }> } sortItems - Sets Dropdown Options
 */
export const propTypes =  {
  sortLabel: PropTypes.string,
  sortItems: PropTypes.arrayOf( PropTypes.shape(
    {
      id: PropTypes.string,
      action: PropTypes.shape( {
        label: PropTypes.string,
        url: PropTypes.string,
        graphql: PropTypes.string
      } ),
      selected: PropTypes.bool
    }
  ) ),
  onChange: PropTypes.func
};



FilterResultsAction.propTypes = propTypes;
export default FilterResultsAction;
